import { cn } from "@/lib/utils";
import DOMPurify from "dompurify";

interface DisplayTextProps extends Omit<
  React.ComponentProps<"div">,
  "children" | "dangerouslySetInnerHTML"
> {
  text: string;
  textAlign?: "left" | "right" | "center" | "justify";
}

const TEXT_ALIGNMENT_OPTION_CLASSNAME_MAP = {
  left: "text-left",
  right: "text-right",
  center: "text-center",
  justify: "text-justify",
};

export function DisplayText({
  className,
  text,
  textAlign = "left",
  ...props
}: Readonly<DisplayTextProps>) {
  const textAlignment = textAlign ?? "left";

  return (
    <div
      className={cn(
        "prose prose-sm",
        TEXT_ALIGNMENT_OPTION_CLASSNAME_MAP[textAlignment],
        className,
      )}
      // Sanitized and then render to prevent XSS vulnerabilities.
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize ? DOMPurify.sanitize(text) : "",
      }}
      {...props}
    />
  );
}
